export const transaction = {
    validation: null,
    getUrl: null,
    getReport: null,
    getCards: null,
    saveCard: null
}